import { Howl } from 'howler';
import gsap, { Expo, Power2, Power3 } from 'gsap';

import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Header from '../layout/Header';
import DefaultNoScroll from './DefaultNoScroll';
import InfiniteScroll from '../_app/cuchillo/scroll/InfiniteScroll';
import InfiniteScroll__Item from '../_app/cuchillo/scroll/InfiniteScroll__Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import Wrap from '../layout/Wrap';
import Preloader from '../layout/Preloader';
import { Basics, isSmartphone } from '../_app/cuchillo/core/Basics';
import Voice from '../layout/Voice';
import { Maths } from '../_app/cuchillo/utils/Maths';
import Audio from '../layout/Audio';
import { parseJSON } from 'date-fns';
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { CSS } from '../_app/cuchillo/utils/CSS';

export default class ProjectInfo extends DefaultNoScroll {
  scroller;
  sliderDom;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor() {
    super();
    Basics.oldPage = "info";
    document.body.classList.add("--remove-footer");

    this._items = [];
    [...GetBy.selector(".__show > *", this.container)].map(dom => { this._items.push(dom); });
    for (let i = 0; i < this._items.length; i++) {
      gsap.set(this._items[i],{opacity:0});
    }

    this._title = GetBy.class("__title", this.container)[0];
    this.setupTitleSize();

    this.projectId = GetBy.class("__main", this.container)[0].dataset.id;

    if(isSmartphone) Header.hide();
    else {
      Header.isOnlyClose = true;
      Header.changeTitle(GetBy.class("__main", this.container)[0].textContent, window.location, true);
    }

    this.sliderDom = GetBy.class('__slider', this.container)[0];
    gsap.set( this.sliderDom,{opacity:0, x:"50%"});
    this.scroller = new InfiniteScroll(InfiniteScroll.AXIS_X, {
      domResize: this.sliderDom,
      container: this.sliderDom,
      multiplicator: 1.3,
      itemClass: ProjectInfoSlider__Item,
      minSpeed: 0,
      inverted: false,
      gap: 0,
      hasVirtuaScroll: true
    });

    
    //this.scroller.directGoto(0.2);
  }

  setupTitleSize() {
    const titleWidth = this._title.getBoundingClientRect().width;
    if(titleWidth > Metrics.WIDTH) {
      this._title.style.transform = CSS.translate3D((Metrics.WIDTH - titleWidth) * (Maths.maxminRandom(8,1)/10),0,0);
    }
  }

  afterShow() {
    super.afterShow();

    this.scroller.show();
    this.scroller.start();

  }

  show__effect() {
    Header.mode = "INVERT";

    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { });
        this.afterShow()
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }

    let delay = .2;
    for (let i = 0; i < this._items.length; i++) { 
      delay = .2 + .1 * i;
      gsap.to(this._items[i],{opacity:1, ease:Power2.easeOut, duration:.3, delay:delay});
    }  
    
    gsap.to(this.sliderDom,{x:0, ease:Expo.easeOut, duration:.8, delay:delay});
    gsap.to(this.sliderDom,{opacity:1, ease:Power2.easeOut, duration:.2, delay:delay + .3});
  }

  beforeHide() {
    this.scroller.hide();
    this.scroller.stop();

    document.body.classList.remove("--remove-footer");
    super.beforeHide();
  }

  afterHide() {
    Voice.getInstance().hide();
    Audio.getInstance().stop();
    Header.show();
    super.afterHide();
  }

  loop() {
    this.scroller.loop();
  }

  resize() {
    this.setupTitleSize();
    this.scroller.resize();
    super.resize();
  }

  dispose() {
    Audio.getInstance().dispose();
    super.dispose();
  }
}

ControllerPage._addPage("project-info", ProjectInfo)


class ProjectInfoSlider__Item extends InfiniteScroll__Item {
  figure = GetBy.selector('figure', this.dom)[0];

  audio;
  audioId;

  subtitles;

  _call = {
    hoverIn: () => { },
    hoverOut: () => { }
  }

  constructor(__d, __i, __axis = InfiniteScroll.AXIS_Y) {
    super(__d, __i, __axis, true);

    const classAlign = Math.floor(Math.random() * 3);
    __d.classList.add(`--pos-${classAlign}`);

    gsap.set(this.figure, { scale: 1.2 });

    if (__d.dataset.audio) {
      let opts = {};

      if (__d.dataset.subtitles !== undefined) {
        opts.subtitles = JSON.parse(__d.dataset.subtitles);
        this.subtitles = opts.subtitles;
      }

      opts.audio = __d.dataset.audio;
      this.audio = opts.audio;
      this.audioId = Audio.getInstance().add(this.audio, opts);
    }
  }

  onShow() {
    if (this.audioId) Audio.getInstance().play(this.audioId);
  }

  onHide() {
    // console.log('HIDE', this.index);
  }

  drawHook() {
    this.move();
  }

  move() {
    //const p = Math.floor(Maths.normalize(-.8, .8, this.progress) * 100);
    //this.figure.style.transformOrigin = `${p}% center`;
  }

  dispose() {
    super.dispose();

    if (this.audioId) Audio.getInstance().dispose(this.audioId);
  }
}
